import React, { useEffect } from 'react';

import SelectInput from 'DesignSystem2/Input/SelectInput';
import SelectOptionsPopover from 'DesignSystem2/Input/SelectOptionsPopover';
import { useStores } from 'hooks/use-stores';
import { noop } from 'utils/noop';

interface BankAccountSelectProps {
    bankId: string;
    className?: string;
    setBankId: React.Dispatch<React.SetStateAction<string>>;
}

const BankAccountSelect = ({ bankId, className = undefined, setBankId }: BankAccountSelectProps): JSX.Element => {
    const { traderStore } = useStores();
    const options = traderStore.bank.accountOptions;
    const selectedText = options.find((option) => option.value === bankId)?.label;

    useEffect(
        () => {
            if (options.length > 0 && !bankId) {
                setBankId(options[0].value);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [options.length],
    );

    return (
        <SelectOptionsPopover options={options} onSelect={setBankId}>
            <SelectInput
                id={'deposit'}
                labelText={!traderStore.bank.numberOfActiveAccounts ? 'No accounts linked' : 'From'}
                errorText={bankId === '' ? 'Must select bank' : undefined}
                name={'deposit-account'}
                selectedText={selectedText}
                onChange={noop}
                className={className}
            />
        </SelectOptionsPopover>
    );
};

export default BankAccountSelect;
